import request from '@/utils/request'

export const getDashboard = () =>
  request({
    url: `/dashboard`,
    method: 'get'
  })
